module.exports = '2.1.5';



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/version.js
// module id = 874
// module chunks = 0